<template>
	<div ref="citaatswiper" class="citaatswiper-scherm">

		<swiper
			:slidesPerView="'1.5'" 
			:space-between="10"
			:centeredSlides="true" 
			:grabCursor="true"
			:pagination='{
				"dynamicBullets": true
			}'
			:direction="'horizontal'"
			:allowTouchMove="true"
			@swiper="onSwiper"
			@slideChange="onSlideChange"
			class='citaatswiper'> 

			<swiper-slide 
				v-for="(stap, index) in citaten" 
				:key="index +'-citaat'"
				class="citaatswiper-slide">

				<div v-if='stap["Type"] === "citaat"' class="knd-citaat">
					<img class="knd-citaat-foto" :src='getImage(stap["Afbeelding"][0].url)' />
					<p class="knd-citaat-titel" v-html='getContent(stap, "Tussenkop")'></p>
					<p v-html='getContent(stap, "Tekst")'></p>
				</div>

			</swiper-slide>


		</swiper>

		
	</div>
</template>

<script>
	import { Swiper, SwiperSlide } from 'swiper/vue';
	import SwiperCore, { Pagination } from 'swiper';

	import "swiper/swiper-bundle.min.css";

	SwiperCore.use([Pagination]);

	export default {
		name: 'Citaatswiper',
		props: ['serie'],
		components: {      
			Swiper,
			SwiperSlide
		},
		data() {
			return {
				citaten: []
			}
		},
		mounted() {
			this.goToSlide(0);

			this.serie.forEach((stap) => {
				if (stap["Type"] === "citaat") {
					this.citaten.push(stap);
				}
			});
		},
		methods: {
			onSwiper(swiper) {
				this.swiper = swiper;
			},

			onSlideChange() {
				///
			},

			goToSlide(index) {
				this.swiper.slideTo(index, 500);
			},

			getContent(content, label) {
				if (this.$store.state.language === "nl") {
					return content[label].data;
				}
				else {
					return content[label].data5891;	
				}
			},

			getImage(imageUrl) {
				return 'https://pointer-dev.kro-ncrv.nl/' + imageUrl;
			}
		}
	}
</script>
